import { render, staticRenderFns } from "./ReceiptLetterheadDialog.vue?vue&type=template&id=653e500b&scoped=true&"
import script from "./ReceiptLetterheadDialog.vue?vue&type=script&lang=js&"
export * from "./ReceiptLetterheadDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptLetterheadDialog.vue?vue&type=style&index=0&id=653e500b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e500b",
  null
  
)

export default component.exports